import styled from "styled-components";
import { Switch } from "antd";
import { theme } from "../../../config";

export const SwitchStyled = styled(Switch)`
  .anticon {
    padding-top: 5px;
  }

  .ant-switch-checked {
    background-color: ${theme.colors.utilities.info} !important;
  }

  .ant-switch-handle::before {
    height: 12px;
    width: 12px;
    top: calc(50% - 12px / 2);
  }

  .ant-switch-handle {
    margin-left: 3px;
  }
`;
